// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs___XhGr","path":"style_path__16Qu-","arrow":"style_arrow__31qL5"};